import { Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const AddToExpandTokens: HandlerType = props => {
    if(props.apiParameter) {
        if(props.apiParameter.expand) {
            props.apiParameter.expand.push("properties");
        }
    }
};

addToChainAfter(chain, PopulateApiParameter, AddToExpandTokens);
